import { FreeMode, Mousewheel, Navigation } from 'swiper';

import { Slider } from './slider';
import { matchMedia } from '../utility';

class RelatedSlider extends Slider {
  init() {
    super.init();
  }
}

export const relatedSlider = () => {
  const containers = document.querySelectorAll('.js-slider-related');
  containers.forEach((container) => {
    const parameters = {
      modules: [FreeMode, Mousewheel, Navigation],
      slidesPerView: 'auto',
      speed: 400,
      spaceBetween: 12,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      freeMode: {
        enabled: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
      },
    };

    const relatedSliderInstance = new RelatedSlider(container, parameters);

    matchMedia('md').addEventListener('change', () => {
      const isMobile = !matchMedia('md').matches;
      if (isMobile) {
        relatedSliderInstance.active();
      } else {
        relatedSliderInstance.inactive();
      }
    });

    const isDesktop = matchMedia('md').matches;
    relatedSliderInstance.init();
    if (isDesktop) relatedSliderInstance.inactive();
  });
};
